const shapeList = ['rectangle', 'triangleLeft', 'triangleRight'];

export default shapeList;
